import React from "react";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import Search from "../components/search/search";
import DashboardTobbar from "../components/DashboardTobbar/DashboardTobbar";

const SearchProfilePage = () => {
  return (
    <>
      <DashboardTobbar />
      <Navbar />
      <div className="row m-0">
        {/* Sidebar */}
        <div className="col-12 col-lg-2 px-0">
          <Sidebar />
        </div>

        {/* Search */}
        <div className="col-12 col-lg-10 px-0">
          <Search />
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default SearchProfilePage;
